import { theme } from 'Assets/Styles/theme'

export const styles = {
  inputWrapper: {
    background: 'rgba(237, 237, 237, 0.5)',
    borderRadius: '4px',
    height: '40px',
    position: 'relative',
    display: 'flex',
    marginBottom: '20px',
  },
  input: {
    height: '40px',
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontSize: '14px',
    lineHeight: '16px',
    padding: '0 20px',
    width: '215px',
    boxSizing: 'border-box',

    '&:placeholder': {
      color: theme.colors.regentGray,
    },

    '&:focus': {
      border: 'none',
      outline: 'none',
    },
  },
  actionLabel: {
    position: 'absolute',
    top: '50%',
    right: '90px',
    transform: 'translateY(-50%)',
    fontFamily: 'Roboto',
    fontSize: '10px',
    lineHeight: '12px',
    color: theme.colors.primary,
  },
  button: {
    height: '40px',
    padding: '0 22px',
    background: theme.colors.primary,
    border: 'none',
    outline: 'none',
    borderRadius: '2px',
    fontSize: '14px',
    lineHeight: '16px',
    color: theme.colors.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  error: {
    position: 'absolute',
    bottom: '-15px',
    fontSize: '10px',
    color: theme.colors.red,
    left: 0,
  },
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spy/SubmitInput/style.js